import React, { useEffect } from "react";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";

const FactsRating = (props) => {
  let ratingClass;

  useEffect(() => {
    ratingClass =
      props?.rating?.readOnly === true ? "half-rating-read" : "half-rating";
  }, [props?.rating?.readOnly]);

  return (
    <Stack spacing={1}>
      <Rating
        name={ratingClass}
        defaultValue={props?.default ?? 0}
        precision={props?.precision ?? 0.5}
      />
    </Stack>
  );
};

export default FactsRating;
